import {
  Box,
  Input,
  InputGroup,
  InputLeftAddon,
  InputRightAddon,
} from '@chakra-ui/react';
import React, { useRef } from 'react';
import { Icon } from './Icon';

type SearchBoxProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  maxWidth?: string | number;
};
export const SearchBox: React.FC<SearchBoxProps> = ({
  value,
  onChange,
  placeholder = 'Search',
  maxWidth,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const onClose = () => {
    if (value === '') {
      return;
    }
    onChange('');
    inputRef.current?.focus();
  };

  return (
    <Box maxW={maxWidth}>
      <InputGroup
        size="sm"
        borderRadius="md"
        border="1px solid"
        borderColor="surface.border"
        _focusWithin={{
          borderColor: 'icon.green',
          boxShadow: '0 0 0 1px var(--chakra-colors-icon-green)',
        }}>
        <InputLeftAddon
          onClick={() => inputRef.current?.focus()}
          bg="transparent"
          border="none"
          borderRight="none"
          px={3}
          cursor="text">
          <Icon iconName="search" color="content.muted" />
        </InputLeftAddon>
        <Input
          ref={inputRef}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          placeholder={placeholder}
          border="none"
          _focus={{
            boxShadow: 'none',
            borderColor: 'transparent',
          }}
          _placeholder={{
            color: 'content.muted',
          }}
          marginLeft={-3}
        />
        {value && (
          <InputRightAddon
            cursor={'pointer'}
            onClick={onClose}
            bg="transparent"
            border="none"
            borderLeft="none"
            px={3}>
            <Icon iconName="close" width={2} color="content.muted" />
          </InputRightAddon>
        )}
      </InputGroup>
    </Box>
  );
};
